export default __webpack_public_path__ + "static/use-b1153f03f2ef216f7bffe019e6557622.jpg";